import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center my-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "ui-card__title" }, " Email messaging settings "),
  /*#__PURE__*/_createElementVNode("p", { class: "ui-card__subtitle" }, " Manage emails for sending email messages in your company ")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "container-px relative min-h-300 flex justify-center items-center"
}
const _hoisted_4 = {
  key: 0,
  class: "text-center flex-grow flex flex-col justify-center items-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl" }, " You have no emails in this company ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, " Add you first email to use email messaging. ", -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-xs font-medium text-dark-blue-500 opacity-50" }
const _hoisted_12 = { class: "group-hover:opacity-100 opacity-0 pr-2 flex" }
const _hoisted_13 = {
  key: 0,
  class: "absolute bottom-0 left-4 right-4 rounded-md py-1 mb-2 bg-dark-blue-400 bg-opacity-10 pl-3 text-sm justify-center mt-2 flex"
}

import { onMounted, ref } from 'vue';
import {
	UiLine,
	UiCard,
	UiConfirmation,
	UiLoader,
	UiButton,
	SvgIcon,
	useLoading
} from '@/ui-kit';
import { useEmails } from '../use-emails';
import { AddEmailDialog } from '../components';
import { MessengerEmail } from '../email.types';
import { useRoute, useRouter } from 'vue-router';
import { useDomains } from '../use-domains';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailsList',
  setup(__props) {

const addEmailDialogRef =
	ref<InstanceType<typeof AddEmailDialog>>();
const confirmationRef =
	ref<InstanceType<typeof UiConfirmation>>();
const selectedEmail = ref<null | MessengerEmail>(null);

const route = useRoute();

const { loading: deleteLoading, toggleLoading } =
	useLoading();
const { emails, isLoading, loadEmails, removeEmail } =
	useEmails();
const { isSytemEmail } = useDomains();

const {
	loading: itemsLoading,
	toggleLoading: toggleItemsLoading
} = useLoading();

async function loadData() {
	toggleItemsLoading();
	await loadEmails();
	toggleItemsLoading();
}

function triggerDeleteEmail(email: MessengerEmail) {
	selectedEmail.value = email;
	confirmationRef.value?.openDialog(
		`Delete ${email.name}?`,
		`You won't be able to use this email to send messages again.`
	);
}

async function deleteEmail() {
	toggleLoading(true);
	await removeEmail(selectedEmail.value!.id);
	confirmationRef.value?.closeDialog();
	toggleLoading(false);
}

onMounted(() => {
	if (route.params.openCreate) {
		addEmailDialogRef.value?.openDialog();
	}

	loadData();
});

const router = useRouter();

function onEmailClick(email: MessengerEmail) {
	if (isSytemEmail(email.email)) {
		return addEmailDialogRef.value?.openDialog(email);
	}

	router.push({
		name: 'EmailDetails',
		params: { emailId: email.id }
	});
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(UiCard), {
      theme: "white",
      class: "relative pt-4 px-4 flex-grow",
      contentClass: "flex flex-col"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_unref(UiButton), {
            class: "!text-sm !h-10 !px-2",
            theme: "primary",
            disabled: _unref(isLoading),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addEmailDialogRef.value?.openDialog()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SvgIcon), {
                class: "h-5 w-5 mr-2",
                name: "only-plus"
              }),
              _createTextVNode("Add Email ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode(_unref(UiLine), { class: "mt-2" }),
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(UiLoader), {
                wrapperClass: "text-reverse",
                loadingText: "Loading emails..."
              })
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_unref(emails).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _hoisted_6,
                    _createVNode(_unref(UiButton), {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (addEmailDialogRef.value?.openDialog())),
                      class: "!text-sm !h-10 !px-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SvgIcon), {
                          class: "h-5 w-5 mr-2",
                          name: "only-plus"
                        }),
                        _createTextVNode("Add Email ")
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(emails), (email) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: email.id,
                      class: _normalizeClass([
						'group flex justify-between items-center mb-1.5 cursor-pointer hover:bg-dark-blue-400 hover:bg-opacity-10 py-1 px-2 rounded-md transition',
						{
							'bg-gray-200 opacity-50':
								!email.valid
						}
					]),
                      onClick: ($event: any) => (onEmailClick(email))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        (email.valid)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 0,
                              "show-after": 500,
                              "hide-after": 0,
                              enterable: false,
                              content: "Email is verified"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SvgIcon), {
                                  name: "check",
                                  class: "h-3 w-3 mt-1.5 mr-2 text-green-400"
                                })
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 1,
                              "show-after": 500,
                              "hide-after": 0,
                              enterable: false,
                              content: "Email is not verified. Click to verify."
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SvgIcon), {
                                  name: "only-close",
                                  class: "h-3 w-3 mt-1.5 mr-2 text-red-400"
                                })
                              ]),
                              _: 1
                            })),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(email.name), 1),
                            (!email.valid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " (Unverfied. Click to verify)"))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(email.email), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_tooltip, {
                          "show-after": 500,
                          "hide-after": 0,
                          enterable: false,
                          content: "Remove email"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SvgIcon), {
                              onClick: _withModifiers(($event: any) => (
									triggerDeleteEmail(
										email
									)
								), ["stop","prevent"]),
                              class: "h-5 w-5 outline-none",
                              name: "close"
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ], 10, _hoisted_7))
                  }), 128)),
              _createVNode(_Transition, {
                "enter-active-class": "transition duration-100 ease-out",
                "enter-from-class": "transform scale-95 opacity-0",
                "enter-to-class": "transform scale-100 opacity-100",
                "leave-active-class": "transition duration-75 ease-in",
                "leave-from-class": "transform scale-100 opacity-100",
                "leave-to-class": "transform scale-95 opacity-0"
              }, {
                default: _withCtx(() => [
                  (_unref(itemsLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createTextVNode(" Syncing email addresses "),
                        _createVNode(_unref(UiLoader), { class: "ml-2" })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_unref(AddEmailDialog), {
      ref_key: "addEmailDialogRef",
      ref: addEmailDialogRef
    }, null, 512),
    _createVNode(_unref(UiConfirmation), {
      ref_key: "confirmationRef",
      ref: confirmationRef,
      loading: _unref(deleteLoading),
      onConfirm: deleteEmail
    }, null, 8, ["loading"])
  ], 64))
}
}

})